import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import UserMenu from '../auth/UserMenu';
import './NavigationHeader.css';

const NavigationHeader = ({ onNavigate, currentPage = 'home' }) => {
  const { user } = useAuth();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const handleNavigation = (target) => {
    if (currentPage === 'home') {
      // On home page, scroll to sections
      scrollToSection(target);
    } else {
      // On other pages, navigate to home first, then scroll
      onNavigate('home');
      // Use setTimeout to ensure the home page is rendered before scrolling
      setTimeout(() => {
        scrollToSection(target);
      }, 100);
    }
  };

  const handleSearchClick = () => {
    handleNavigation('artists');
  };


  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav">
          <div className="logo" onClick={() => onNavigate('home')}>
            <img src="/logo.png" alt="LIVESTA" />
          </div>
          <div className="search-bar" onClick={handleSearchClick}>
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search..." readOnly />
          </div>
          <nav className={`nav-links ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <button onClick={() => handleNavigation('home')}>Home</button>
            <button onClick={() => handleNavigation('community')}>Community</button>
            {user && (
              <button onClick={() => handleNavigation('favorites')}>My Favorites</button>
            )}
            {/* <button onClick={() => handleNavigation('music')}>Music</button> */}
          </nav>
          <UserMenu onNavigate={onNavigate} />
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default NavigationHeader; 